import { sanitizeContentfulBlockId } from 'utils/contentful';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import styles from './QuickDetails.module.scss';
import RichText from './RichText';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type {
  IBlockQuickDetailsFields,
  IBlockQuickDetailsItem,
} from 'types/contentful/generated';

type Props = IBlockQuickDetailsFields & {
  inspectorProps?: InspectorPropsType;
};

const QuickDetails = ({
  blockId,
  title,
  quickDetails,
  inspectorProps,
}: Props): JSX.Element => {
  // eslint-disable-next-line
  // @ts-ignore
  const items: IBlockQuickDetailsItem[] = quickDetails.items || quickDetails;

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      <h2 {...inspectorProps?.({ fieldId: 'title' })}>{title}</h2>
      <div className={styles.grid}>
        {items.map((detail, i) => {
          const inspectorPropsForDetails = useContentfulInspectorMode({
            entryId: detail?.sys?.id,
          });
          const { text, title } = detail.fields || detail;

          return (
            <div key={i} className={styles.item}>
              <h3
                className={styles.itemHeadline}
                {...inspectorPropsForDetails?.({ fieldId: 'title' })}
              >
                {title}
              </h3>
              <RichText
                fields={text}
                inspectorProps={{
                  ...inspectorPropsForDetails?.({ fieldId: 'text' }),
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuickDetails;
